export default "__VITE_ASSET__BOPROLm5__"